/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AuthEmailConfirmReq,
  AuthEmailReq,
  AuthorizationForGoogleTokenRequest,
  GoogleAuthorizationCallbackParams,
  SuccessBodyAuthEmailRes,
  SuccessBodyAuthResWithPlanType,
  SuccessBodyMapStringString,
  SuccessBodyString,
  WhalespaceCallbackParams,
  WhalespaceV2CallbackParams
} from '.././_model';

import { httpsInstance } from '../../httpClient';
import type { ErrorType , BodyType } from '../../httpClient';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const requestEmailLoginCode = (
    authEmailReq: BodyType<AuthEmailReq>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyAuthEmailRes>(
      {url: `/login/email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authEmailReq, signal
    },
      options);
    }
  


export const getRequestEmailLoginCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmailLoginCode>>, TError,{data: BodyType<AuthEmailReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestEmailLoginCode>>, TError,{data: BodyType<AuthEmailReq>}, TContext> => {

const mutationKey = ['requestEmailLoginCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestEmailLoginCode>>, {data: BodyType<AuthEmailReq>}> = (props) => {
          const {data} = props ?? {};

          return  requestEmailLoginCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestEmailLoginCodeMutationResult = NonNullable<Awaited<ReturnType<typeof requestEmailLoginCode>>>
    export type RequestEmailLoginCodeMutationBody = BodyType<AuthEmailReq>
    export type RequestEmailLoginCodeMutationError = ErrorType<unknown>

    export const useRequestEmailLoginCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmailLoginCode>>, TError,{data: BodyType<AuthEmailReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestEmailLoginCode>>,
        TError,
        {data: BodyType<AuthEmailReq>},
        TContext
      > => {

      const mutationOptions = getRequestEmailLoginCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const confirmEmailLogin = (
    authEmailConfirmReq: BodyType<AuthEmailConfirmReq>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyAuthResWithPlanType>(
      {url: `/login/email/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authEmailConfirmReq, signal
    },
      options);
    }
  


export const getConfirmEmailLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailLogin>>, TError,{data: BodyType<AuthEmailConfirmReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmEmailLogin>>, TError,{data: BodyType<AuthEmailConfirmReq>}, TContext> => {

const mutationKey = ['confirmEmailLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmEmailLogin>>, {data: BodyType<AuthEmailConfirmReq>}> = (props) => {
          const {data} = props ?? {};

          return  confirmEmailLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmEmailLoginMutationResult = NonNullable<Awaited<ReturnType<typeof confirmEmailLogin>>>
    export type ConfirmEmailLoginMutationBody = BodyType<AuthEmailConfirmReq>
    export type ConfirmEmailLoginMutationError = ErrorType<unknown>

    export const useConfirmEmailLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailLogin>>, TError,{data: BodyType<AuthEmailConfirmReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmEmailLogin>>,
        TError,
        {data: BodyType<AuthEmailConfirmReq>},
        TContext
      > => {

      const mutationOptions = getConfirmEmailLoginMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getTokenAndGoogleAccessTokenByAuthorizationCode = (
    authorizationForGoogleTokenRequest: BodyType<AuthorizationForGoogleTokenRequest>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyMapStringString>(
      {url: `/auth/google/token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authorizationForGoogleTokenRequest, signal
    },
      options);
    }
  


export const getGetTokenAndGoogleAccessTokenByAuthorizationCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>, TError,{data: BodyType<AuthorizationForGoogleTokenRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>, TError,{data: BodyType<AuthorizationForGoogleTokenRequest>}, TContext> => {

const mutationKey = ['getTokenAndGoogleAccessTokenByAuthorizationCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>, {data: BodyType<AuthorizationForGoogleTokenRequest>}> = (props) => {
          const {data} = props ?? {};

          return  getTokenAndGoogleAccessTokenByAuthorizationCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>>
    export type GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationBody = BodyType<AuthorizationForGoogleTokenRequest>
    export type GetTokenAndGoogleAccessTokenByAuthorizationCodeMutationError = ErrorType<unknown>

    export const useGetTokenAndGoogleAccessTokenByAuthorizationCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>, TError,{data: BodyType<AuthorizationForGoogleTokenRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTokenAndGoogleAccessTokenByAuthorizationCode>>,
        TError,
        {data: BodyType<AuthorizationForGoogleTokenRequest>},
        TContext
      > => {

      const mutationOptions = getGetTokenAndGoogleAccessTokenByAuthorizationCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const refreshGoogleAccessToken = (
    
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyString>(
      {url: `/auth/google/refresh-token`, method: 'POST', signal
    },
      options);
    }
  


export const getRefreshGoogleAccessTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshGoogleAccessToken>>, TError,void, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshGoogleAccessToken>>, TError,void, TContext> => {

const mutationKey = ['refreshGoogleAccessToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshGoogleAccessToken>>, void> = () => {
          

          return  refreshGoogleAccessToken(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshGoogleAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshGoogleAccessToken>>>
    
    export type RefreshGoogleAccessTokenMutationError = ErrorType<unknown>

    export const useRefreshGoogleAccessToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshGoogleAccessToken>>, TError,void, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshGoogleAccessToken>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRefreshGoogleAccessTokenMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary [Deprecated] Whalespace OAuth v2 OIDC Callback
 */
export const whalespaceV2Callback = (
    params: WhalespaceV2CallbackParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<unknown>(
      {url: `/auth/whalespace/v2/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWhalespaceV2CallbackQueryKey = (params: WhalespaceV2CallbackParams,) => {
    return [`/auth/whalespace/v2/callback`, ...(params ? [params]: [])] as const;
    }

    
export const getWhalespaceV2CallbackQueryOptions = <TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWhalespaceV2CallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof whalespaceV2Callback>>> = ({ signal }) => whalespaceV2Callback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WhalespaceV2CallbackQueryResult = NonNullable<Awaited<ReturnType<typeof whalespaceV2Callback>>>
export type WhalespaceV2CallbackQueryError = ErrorType<unknown>


export function useWhalespaceV2Callback<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceV2Callback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceV2Callback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceV2Callback<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceV2Callback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceV2Callback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceV2Callback<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary [Deprecated] Whalespace OAuth v2 OIDC Callback
 */

export function useWhalespaceV2Callback<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWhalespaceV2CallbackQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWhalespaceV2CallbackSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWhalespaceV2CallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof whalespaceV2Callback>>> = ({ signal }) => whalespaceV2Callback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WhalespaceV2CallbackSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof whalespaceV2Callback>>>
export type WhalespaceV2CallbackSuspenseQueryError = ErrorType<unknown>


export function useWhalespaceV2CallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceV2CallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceV2CallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary [Deprecated] Whalespace OAuth v2 OIDC Callback
 */

export function useWhalespaceV2CallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceV2Callback>>, TError = ErrorType<unknown>>(
 params: WhalespaceV2CallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceV2Callback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWhalespaceV2CallbackSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @deprecated
 * @summary [Deprecated] Whalespace OAuth v1 Callback
 */
export const whalespaceCallback = (
    params: WhalespaceCallbackParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<unknown>(
      {url: `/auth/whalespace/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWhalespaceCallbackQueryKey = (params: WhalespaceCallbackParams,) => {
    return [`/auth/whalespace/callback`, ...(params ? [params]: [])] as const;
    }

    
export const getWhalespaceCallbackQueryOptions = <TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(params: WhalespaceCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWhalespaceCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof whalespaceCallback>>> = ({ signal }) => whalespaceCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WhalespaceCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof whalespaceCallback>>>
export type WhalespaceCallbackQueryError = ErrorType<unknown>


export function useWhalespaceCallback<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceCallback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceCallback<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof whalespaceCallback>>,
          TError,
          Awaited<ReturnType<typeof whalespaceCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceCallback<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @deprecated
 * @summary [Deprecated] Whalespace OAuth v1 Callback
 */

export function useWhalespaceCallback<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWhalespaceCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWhalespaceCallbackSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(params: WhalespaceCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWhalespaceCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof whalespaceCallback>>> = ({ signal }) => whalespaceCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WhalespaceCallbackSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof whalespaceCallback>>>
export type WhalespaceCallbackSuspenseQueryError = ErrorType<unknown>


export function useWhalespaceCallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceCallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWhalespaceCallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @deprecated
 * @summary [Deprecated] Whalespace OAuth v1 Callback
 */

export function useWhalespaceCallbackSuspense<TData = Awaited<ReturnType<typeof whalespaceCallback>>, TError = ErrorType<unknown>>(
 params: WhalespaceCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof whalespaceCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWhalespaceCallbackSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Google OAuth callback - Use Auth Server instead
 * @summary [Deprecated] Google OAuth Callback
 */
export const googleAuthorizationCallback = (
    params: GoogleAuthorizationCallbackParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<unknown>(
      {url: `/auth/google/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGoogleAuthorizationCallbackQueryKey = (params: GoogleAuthorizationCallbackParams,) => {
    return [`/auth/google/callback`, ...(params ? [params]: [])] as const;
    }

    
export const getGoogleAuthorizationCallbackQueryOptions = <TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGoogleAuthorizationCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof googleAuthorizationCallback>>> = ({ signal }) => googleAuthorizationCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GoogleAuthorizationCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof googleAuthorizationCallback>>>
export type GoogleAuthorizationCallbackQueryError = ErrorType<unknown>


export function useGoogleAuthorizationCallback<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleAuthorizationCallback>>,
          TError,
          Awaited<ReturnType<typeof googleAuthorizationCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGoogleAuthorizationCallback<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleAuthorizationCallback>>,
          TError,
          Awaited<ReturnType<typeof googleAuthorizationCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGoogleAuthorizationCallback<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary [Deprecated] Google OAuth Callback
 */

export function useGoogleAuthorizationCallback<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGoogleAuthorizationCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGoogleAuthorizationCallbackSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGoogleAuthorizationCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof googleAuthorizationCallback>>> = ({ signal }) => googleAuthorizationCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GoogleAuthorizationCallbackSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof googleAuthorizationCallback>>>
export type GoogleAuthorizationCallbackSuspenseQueryError = ErrorType<unknown>


export function useGoogleAuthorizationCallbackSuspense<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGoogleAuthorizationCallbackSuspense<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGoogleAuthorizationCallbackSuspense<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary [Deprecated] Google OAuth Callback
 */

export function useGoogleAuthorizationCallbackSuspense<TData = Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError = ErrorType<unknown>>(
 params: GoogleAuthorizationCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof googleAuthorizationCallback>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGoogleAuthorizationCallbackSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



